import { Connector, CustomFilterChip, SortComponent } from '#/DefaultViewExtensionInterfaces';
import Utilities from '@/Utility/Utilities';

export default class CustomFilterChipBuilder {

    private displayName: string;
    private filterTerm: string;
    private isActive: boolean;

    constructor(displayName: string) {
        this.displayName = displayName;
        this.filterTerm = '';
        this.isActive = false;
    }

    public useFilterStatement(statement: string): CustomFilterChipBuilder {
        this.filterTerm = statement;
        return this;
    }

    public isActiveOnOpen(active: boolean): CustomFilterChipBuilder {
        this.isActive = active;
        return this;
    }

    public build(): CustomFilterChip {
        if (Utilities.isNullOrUndefinedOrBlank(this.displayName))
            return null;

        return {
            filterTerm: this.filterTerm,
            displayName: this.displayName,
            active: this.isActive,
        } as CustomFilterChip;
    }
}